/**
 * LoginWallContestContext — dispatch-A copy block for the auth
 * wall when the user is on their way to enter the contest.
 *
 * Feb 2026 dispatch. Rationale: contest entrants arriving at
 * `/login?next=/contest/enter` are overwhelmingly new users; the
 * default "Welcome back" framing at `/login` implies an existing
 * account and buries the sign-up path. This block replaces (or
 * augments) the default framing with contest-aware copy so the
 * funnel doesn't friction on the last mile.
 *
 * Rendered by `Login.jsx` AND `Signup.jsx` when
 * `next === "/contest/enter"`. Absent otherwise — no default-flow
 * copy leak.
 *
 * Voice pull-throughs from `memory/launch_copy_omaha_2026.md`:
 *   - "Cutest Pluck on the Block" — canonical contest name.
 *   - "free Pluck on us" — winner reward framing (colloquial).
 *   - "rally your neighborhood" — mirrors the entrant status card
 *     copy in ContestEnterPage.jsx: "Now rally your friends and
 *     family to vote!"
 */
import React from "react";
import { Trophy } from "lucide-react";

export const LOGIN_WALL_CONTEST_HEADLINE =
  "Almost there — create a free account to enter your pup 🐾";

export const LOGIN_WALL_CONTEST_SUBCOPY =
  "You're one quick account away from the Cutest Pluck on the Block. " +
  "Enter your pup, rally your neighborhood, and every winner takes " +
  "home a free Pluck on us.";

export default function LoginWallContestContext() {
  return (
    <div
      className="mb-6 rounded-3xl border border-brand-orange/30 bg-brand-orange/5 p-5"
      data-testid="login-wall-contest-context"
    >
      <div className="flex items-start gap-3">
        <div
          className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-orange/15"
          aria-hidden="true"
        >
          <Trophy className="h-5 w-5 text-brand-orange" />
        </div>
        <div>
          <p
            className="font-heading text-base font-bold text-pp-text"
            data-testid="login-wall-contest-context-headline"
          >
            {LOGIN_WALL_CONTEST_HEADLINE}
          </p>
          <p
            className="mt-1 text-sm text-muted-foreground"
            data-testid="login-wall-contest-context-subcopy"
          >
            {LOGIN_WALL_CONTEST_SUBCOPY}
          </p>
        </div>
      </div>
    </div>
  );
}
